module.exports = "/static/assets/b6b8630fa9df06dd65ac79d74298bc03.png";